import React from 'react'
import { Grid, GridCell } from '@mobi/component-library/Legacy/Grid'
import { getOrdinalSuffix } from '@mobi/utils/number/ordinal'
import { DogsFormRaceResponse } from '@core/Areas/Racing/Hooks/useRaceFormData/api'
import { HistoryExpandable } from '../Common/HistoryExpandable'

type DogsHistorySingleProps = {
  history: DogsFormRaceResponse['Forms'][0]['Histories'][0]
  StarterName?: string
}

export const DogsHistorySingle: React.FC<DogsHistorySingleProps> = ({
  history: {
    Place,
    RaceNumber,
    BarrierBox,
    TrackName,
    FixtureDate,
    Distance,
    StewardsComments,
    RaceClass,
    StartingPrice,
    Margin,
    RaceTime,
    RaceSecTime,
    BodyWeight,
    Placings,
    RaceReplay,
    SettlePosition,
    TurnPosition,
  },
  StarterName,
}) => {
  return (
    <HistoryExpandable
      Place={Place}
      RaceNumber={RaceNumber}
      TrackName={TrackName}
      FixtureDate={FixtureDate}
      Distance={Distance}
      RaceReplay={RaceReplay}
      StarterName={StarterName}
      StarterNumber={Number(BarrierBox)}
      RaceCode='dogs'
    >
      <>
        {StewardsComments && StewardsComments !== '.' && StewardsComments !== '-' && (
          <div data-testid='form-history-stewards-comments'>
            <strong>Stewards Comments</strong> {StewardsComments}
          </div>
        )}
        <Grid>
          <GridCell width='50%'>
            <div data-testid='form-history-class'>
              <strong>Class</strong> {RaceClass}
            </div>
            <div data-testid='form-history-racetime'>
              <strong>Race Time</strong> {RaceTime}
            </div>

            <div data-testid='form-history-sectime'>
              <strong>Sec. Time</strong> {RaceSecTime || '-'}
            </div>
            <div data-testid='form-history-margin'>
              <strong>Margin</strong> {Margin}
            </div>
            <div data-testid='form-history-startprice'>
              <strong>Start Price</strong> {StartingPrice}
            </div>
          </GridCell>

          <GridCell width='50%'>
            <div data-testid='form-history-dist'>
              <strong>Dist</strong> {Distance}
            </div>
            <div data-testid='form-history-box'>
              <strong>Box</strong> {BarrierBox}
            </div>
            <div data-testid='form-history-weight'>
              <strong>Weight</strong> {BodyWeight}
            </div>

            <div data-testid='form-history-settle'>
              <strong>Settle</strong> {formatPosition(SettlePosition) || 'N/A'}
            </div>

            <div data-testid='form-history-turn'>
              <strong>Turn</strong> {formatPosition(TurnPosition) || 'N/A'}
            </div>
          </GridCell>
        </Grid>
        {Placings.length && (
          <div>
            <ol>
              {Placings.map(({ Place, StarterName, Margin, Barrier }) => (
                <li key={Place}>
                  <strong>{Place}</strong>
                  <span>
                    {StarterName} {Barrier && `(${Barrier})`}
                  </span>
                  {Margin && <div>{formatMargin(Margin)}</div>}
                </li>
              ))}
            </ol>
          </div>
        )}
      </>
    </HistoryExpandable>
  )
}

// Local Helpers
const formatMargin = (margin?: string): string => {
  if (!margin) return ''

  const numericMargin = Number(margin)
  return Number.isFinite(numericMargin) ? numericMargin.toFixed(2) : margin
}

const formatPosition = (position?: string): string => {
  if (!position) return ''

  const numericPosition = Number(position)
  if (!Number.isInteger(numericPosition) || numericPosition <= 0) return position

  return `${numericPosition}${getOrdinalSuffix(numericPosition)}`
}
